import axios from 'axios';
import PropTypes from 'prop-types';
import React from 'react';

import { PromotionalAdContext as Context } from './ContextCreator';

export class PromotionalAdProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ads: [],
            getAdAtPosition: this.getAdAtPosition,
        };
    }

    static propTypes = {
        pageKey: PropTypes.string,
        isMobile: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        pageKey: null,
    };

    _updateAdByPosition = (position, ad, cb = () => {}) => {
        const ads = this.state.ads;
        ads[position] = ad;
        this.setState({ ads: ads }, cb);
    };

    _fetchPromotionalAd = async (position) => {
        try {
            const res = await axios.post('/api/promotional-ad/master-feed-ad', {
                isMobile: this.props.isMobile,
                pageKey: this.props.pageKey,
            });

            this._updateAdByPosition(position, {
                isLoading: false,
                adInfo: res.data.data,
            });
        } catch (e) {
            this._updateAdByPosition(
                position,
                {
                    isLoading: false,
                    adInfo: null,
                },
                () => console.log(e)
            );
        }
    };

    getAdAtPosition = (position) => {
        let ad = this.state.ads[position];
        if (!ad) {
            ad = {
                isLoading: true,
                adInfo: null,
            };

            this._updateAdByPosition(position, ad, () =>
                this._fetchPromotionalAd(position)
            );
        }
        return ad;
    };

    render() {
        return (
            <Context.Provider value={this.state}>
                {this.props.children}
            </Context.Provider>
        );
    }
}

export const PromotionalAdConsumer = Context.Consumer;
